<template>
  <div class="address">
    <Navbar title="地址" path="/"/>
    <div class="clearfix topBg header">
      <div class="bedroom-max">
        <span>{{ roomName }}</span>&nbsp;&nbsp;
        <span>{{ bedName }}</span>
      </div>
      <div class="bedroom-min">
        <span v-if="!bedName && !roomName">地址未录入，请联系工作人员录入地址</span>
        <div v-else>
          <span>护理站：{{ roomName }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span>床位号：{{ bedName }}</span>
        </div>
      </div>
    </div>
    <div class="btnGroup">
      <button class="themeColor" @click="bindUserBed">使用地址</button>
      <button @click="toPages('/index/editQrCode',uuid)" v-if="userType == '1' || userType == '2'">修改地址信息</button>
    </div>
    <div class="article">
      <div v-html="article"></div>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Dialog, Toast} from "vant";

export default {
  name: "Address",
  components: {Navbar},
  data() {
    return {
      uuid: "",
      bedName: "",//床位号
      roomName: "",//护理站
      user_token: "",
      userType: 0,
      article: ''
    }
  },
  created() {
    let str = window.location.href;
    this.uuid = str.split('?')[1].replace("=","");
  },
  mounted() {
    this.user_token = localStorage.getItem('user_token');
    this.userType = localStorage.getItem('user_type');
    window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href));
    this.getUserBedNumber();
    this.getArticle();
  },
  methods: {
    toPages(url, uuid = "") {
      if (!this.user_token) {
        Dialog.confirm({
          message: "您还未登录,请前往登录页！",
          confirmButtonText: "前往",
          confirmButtonColor: '#126AFC',
        }).then(() => {
          this.goLogin()
        }, () => {

        })
      } else {
        if (url === '/') {
          this.$router.push(url)
        } else {
          let userType = localStorage.getItem('user_type');
          if (userType == '1' || userType == '2') {
            this.$router.push({path: url, query: {uuid}});
          } else {
            Toast('您没有修改权限，请联系医护人员修改');
          }
        }
      }
    },
    //获取用户床号
    getUserBedNumber() {
      this.$post('address/info', {uuid: this.uuid}).then(result => {
        if (result.status === 200) {
          this.roomName = result.data.roomName;
          this.bedName = result.data.bedName;
        }
      });
    },
    goLogin() {
      this.$router.push('/login');
    },
    //绑定用户床号
    bindUserBed() {
      if (!this.user_token) {
        Dialog.confirm({
          message: "您还未登录,请前往登录页！",
          confirmButtonText: "前往",
          confirmButtonColor: '#126AFC',
        }).then(() => {
          this.goLogin()
        }, () => {

        })
      } else {
        let data = {
          uuid: this.uuid
        }
        this.$post('address/useAddress', data).then(result => {
          if (result.status === 200) {
            this.toPages('/');
            Toast('绑定成功');
          } else {
            return Toast(result.msg);
          }
        });
      }
    },
    //获取文章
    getArticle() {
      this.$post('article/info', {type: 'user_guidance'}).then(res => {
        if (res.status !== 200) return Toast(res.msg);
        this.article = res.data;
      })
    }
  },
}
</script>

<style scoped lang="less">
.address {
  font-size: 14px;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .bedroom-max {
      margin-top: 35px;
      font-size: 30px;
      font-weight: bold;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }

    .bedroom-min {
      margin-top: 25px;

      div {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        span {
          white-space: nowrap;
        }
      }
    }
  }

  .btnGroup {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 15px;
    box-sizing: border-box;

    button {
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }

    button:nth-child(2) {
      margin-top: 40px;
      border: 1px solid #126AFC;
      color: #126AFC;
      font-weight: normal;
      background: transparent;
    }
  }

  .article {
    width: 100%;
    padding: 40px 15px 40px 15px;
    box-sizing: border-box;
  }
}
</style>